module.exports = __webpack_public_path__ + "static/media/cross_embed.79d088b2.svg";